module.exports = "{{title}}\n"